// Reapply a table or profile editor's additions and removals to the latest
// saved values. Concurrently learned values survive unless the person
// explicitly removed them from the draft. Values are compared by exact text.
export const diffValueEdits = (base, local) => {
  const added = {};
  const removed = {};
  const columns = new Set([...Object.keys(base || {}), ...Object.keys(local || {})]);
  columns.forEach((column) => {
    const baseValues = new Set(base?.[column] || []);
    const localValues = new Set(local?.[column] || []);
    added[column] = [...localValues].filter((value) => !baseValues.has(value));
    removed[column] = [...baseValues].filter((value) => !localValues.has(value));
  });
  return { added, removed };
};

export const applyValueEdits = (remote, { added, removed }) => {
  const out = {};
  const columns = new Set([...Object.keys(remote || {}), ...Object.keys(added || {})]);
  columns.forEach((column) => {
    const gone = new Set(removed?.[column] || []);
    const kept = (remote?.[column] || []).filter((value) => !gone.has(value));
    const extra = (added?.[column] || []).filter((value) => !kept.includes(value));
    if (kept.length > 0 || extra.length > 0 || Object.prototype.hasOwnProperty.call(remote || {}, column)) {
      out[column] = [...kept, ...extra];
    }
  });
  return out;
};

